import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    paper: {
      overflowY: "initial",
      padding: [36, 24],
      width: 271,
      borderRadius: 10,
      boxShadow: "0 3px 6px 0 rgba(0,0,0,.25)",
      position: "relative",
      [theme.breakpoints.up("mobile")]: {
        width: 572,
        padding: [40, 45, 60],
        borderRadius: 22,
      },
    },
    logo: {
      display: "block",
      margin: [0, "auto", 50],
      width: 206,
      [theme.breakpoints.up("mobile")]: {
        width: 332,
      },
    },
    description: {
      maxWidth: 241,
      margin: [0, "auto", 35],
      [theme.breakpoints.up("mobile")]: {
        maxWidth: 480,
      },
    },
  }),
  { name: "JoinModal" },
);
